export default __webpack_public_path__ + "static/media/line.814ef284.svg";